import React, { useState, useEffect, useRef } from "react";

function ADDSelect(props) {
  const {
    label,
    name,
    id,
    fieldId,
    isRequired,
    errId,
    divClass,
    options,
    fieldName,
    fieldValue,
    handleSelectChange,
    checkDetailsIndex,
    hasError,
  } = props;

  const handleOnChange = (e) => {
    handleSelectChange(e.target);
  };

  return (
    <>
      <div className="col-sm-4 col-md-12 col-xl-4">
        <div className="form-group">
          <div className="floating-label tp-dropdown">
            <select
              name={name}
              id={id}
              className="form-control"
              onChange={(e) => handleOnChange(e)}
              data-checkdetailsindex={checkDetailsIndex}
              data-fieldname={fieldName}
              style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
            >
              <option value=""></option>
              {options &&
                Object.entries(options).map((option) => {
                  return (
                    <option
                      value={option[0]}
                      selected={fieldValue == option[0] ? true : false}
                    >
                      {option[1]}
                    </option>
                  );
                })}
            </select>
            <label htmlFor={name} className={fieldValue && "focused"}>
              {label}
              {isRequired == 1 && <sup className="text-danger">*</sup>}
            </label>
          </div>
          {hasError === true && (
            <p className="err text-danger" id={errId}>
              This field is required.
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default ADDSelect;
